var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderComponent'),_vm._v(" "),_c('FeaturesComponent'),_vm._v(" "),_c('EventsComponent'),_vm._v(" "),_c('SignUpComponent'),_vm._v(" "),_c('LogoComponent'),_vm._v(" "),_c('ContactComponent'),_vm._v(" "),_c('PartnersComponent')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d8cf76e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 